import { RestClient } from '@/modules/axios';

export default {
    state: {
        registerClientModule: null,
    },
    getters: {},
    mutations: {},
    actions: {
        fetchPassword({ dispatch }, payload) {
            return dispatch('getRegisterClientModule')
                .then((register) => {
                    return register.post('/api/register', payload).then((result) => {
                        console.log('GET RESPONSE in the store: ', result.data);
                        return Promise.resolve();
                    });
                })
                .catch((error) => {
                    console.log('PASSWORD UPLOAD ERROR: ', error.response);
                    return Promise.reject();
                });
        },

        getRegisterClientModule(context) {
            if (!context.state.registerClientModule) {
                context.state.registerClientModule = new RestClient('', context);
            }
            return context.state.registerClientModule;
        },
    },
};
